import React, { useEffect, useState } from "react";
import { Stack, Tab, Tabs } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { fontSize } from "@utils/tokens";
import PageHeader from "@components/shared/ui/PageHeader";
import SurfaceCard from "@components/shared/ui/SurfaceCard";

type Tabs = "progress" | "performance" | null;

const AnalyticsTabs = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<Tabs>("progress");

  const handleChange = (_e: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue as Tabs);
    navigate(`${newValue}`);
  };

  useEffect(() => {
    setActiveTab(pathname.match(/performance/gi) ? "performance" : "progress");
  }, [pathname]);

  if (!activeTab) return;

  return (
    <Stack spacing={2}>
      <PageHeader eyebrow="Teacher" title="Analysis" />

      <SurfaceCard sx={{ borderRadius: "16px 16px 0 0" }}>
        <Stack sx={{ borderBottom: 2, borderColor: "divider" }}>
          <Tabs
            value={activeTab}
            variant="fullWidth"
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            {tabs.map((t, index) => (
              <Tab
                key={index}
                label={t.label}
                value={t.path}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 500,
                  py: 3,
                  fontSize: fontSize.lg,
                }}
              />
            ))}
          </Tabs>
        </Stack>

        <Outlet />
      </SurfaceCard>
    </Stack>
  );
};

export default AnalyticsTabs;

const tabs = [
  {
    id: "1",
    path: "progress",
    label: "progress",
  },
  {
    id: "2",
    path: "performance",
    label: "performance",
  },
];
